import {
  FormControlLabel,
  FormLabel,
  FormControl,
  RadioGroup as MuiRadioGroup,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ColorRadio from './Radio';
import { HighlightColor } from '../../types';
import { HighlightColorSet } from '../../../Highlighting/types';

export default function RadioGroup({
  color,
  onChange,
  srOnlyLabel = false,
  hideLabels = false,
}: Readonly<{
  color?: string | null;
  onChange: (color: HighlightColor) => void;
  srOnlyLabel?: boolean;
  hideLabels?: boolean;
}>) {
  const { t } = useTranslation();
  const formattedColor = color;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as HighlightColor);
  };

  return (
    <FormControl>
      {!srOnlyLabel && (
        <FormLabel id='annotation-color-radio-group'>Korostusväri</FormLabel>
      )}
      <MuiRadioGroup
        aria-labelledby='annotation-color-radio-group'
        name='annotation-color'
        row
        value={formattedColor}
        onChange={handleChange}
        sx={
          hideLabels
            ? {
                gap: 0.25,
              }
            : {}
        }
      >
        {HighlightColorSet.map((highlightColor) => (
          <FormControlLabel
            key={'color-radio' + highlightColor}
            value={highlightColor}
            control={
              <ColorRadio colorName={highlightColor} hideLabel={hideLabels} />
            }
            label={
              hideLabels ? undefined : t(`bookmarks.color.${highlightColor}`)
            }
            sx={
              hideLabels
                ? {
                    marginLeft: 0,
                    marginRight: 0,
                  }
                : {}
            }
          />
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
}
